import Avatar from "../assets/Avatar";
import GlassCard from "../components/GlassCard";

export default function PostCard({ post }) {
  return (
    <GlassCard className="p-4 mb-3">
      <div className="flex gap-3">
        <Avatar initials="U" />

        <div className="flex-1">
          <div className="flex items-center gap-2 text-sm">
            <span className="font-bold text-gray-800">
              User {post.userId}
            </span>
            <span className="text-gray-400 text-xs">
              @{post.userId}
            </span>
            <span className="ml-auto text-xs text-gray-300">
              {post.createdAt?.slice(0, 10)}
            </span>
          </div>

          <p className="mt-2 text-sm text-gray-700 leading-relaxed">
            {post.content}
          </p>

          <div className="flex items-center gap-4 mt-3 text-xs text-gray-400">
            <span className="flex items-center gap-1">
              ❤️ {post.likes || 0}
            </span>
            <span className="flex items-center gap-1">
              💬 {post.comments || 0}
            </span>
          </div>
        </div>
      </div>
    </GlassCard>
  );
}